import { Theme } from '@mui/material';
import { useTheme } from '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';
import { CSSProperties } from 'react';

export type StatusChipVariantType = 'blue' | 'green' | 'red' | 'grey';
type StatusColorMapObjectType = { [key in StatusChipVariantType]: CSSProperties['color'] };

const statusColorMap = (theme: Theme): StatusColorMapObjectType => ({
    blue: theme.colors.blue,
    green: theme.palette.success.main,
    red: theme.palette.error.main,
    grey: theme.colors.grey,
});

const useStyles = makeStyles((theme) => ({
    container: (props: StatusChipProps) => ({
        background: props.variant
            ? statusColorMap(theme)[props.variant]
            : statusColorMap(theme)['grey'],
        borderRadius: theme.layout.borderRadius.large,
        color: 'white',
        padding: theme.spacing(0.3, 0.875),
        fontSize: 11,
    }),
}));

interface StatusChipProps {
    text: string;
    variant: StatusChipVariantType;
}

export const StatusChip = (props: Readonly<StatusChipProps>) => {
    const theme = useTheme();
    const classes = useStyles(props);

    return (
        <div
            className={classes.container}
            style={{
                background: statusColorMap(theme)[props.variant],
            }}
        >
            {props.text}
        </div>
    );
};
